import { render } from "./PageProfissional.vue?vue&type=template&id=fae57f08&scoped=true"
import script from "./PageProfissional.vue?vue&type=script&lang=js"
export * from "./PageProfissional.vue?vue&type=script&lang=js"

import "./PageProfissional.vue?vue&type=style&index=0&id=fae57f08&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fae57f08"]])

export default __exports__